export function isBasicPropertyType(propertyType) {
    return [String, Number, Date, Boolean].find((t) => propertyType === t);
}
